import React from 'react';
import RegressionPredictor from './RegressionPredictor';

const RegressionModels = (props) => {
  return (
    <div class="container">
      <h3>Correlation between Anthrax Cases and Meteorological Factors</h3>
      <RegressionPredictor />
      <hr />
      <p>
        We constructed three generalized linear models with Poisson distribution to
        analyze the impact of various meteorological factors on
        anthrax cases in Gannan (especially in Maqu county).
        For all models, all independent variables were standardized, and
        AIC was used to select variables. The three final models are as follows:
      </p>
      <ol>
        <li>
          Anthrax cases ~ temperature + precipitation + wind speed + sunshine duration + relative humidity
        </li>
        <li>
          Anthrax cases ~ temperature + 1 month lag temperature + precipitation + wind speed + sunshine duration + 1 month lag sunshine duration + relative humidity + 1 month lag relative humidity + pressure
        </li>
        <li>
          Anthrax cases ~ 1 month lag heat index + precipitation + wind speed + sunshine duration + pressure
        </li>
      </ol>
      <p>
        where all meteorological factors are monthly averages, the dependent variable is the total anthrax cases (in Maqu county) in one month.
      </p>
    </div>
  );
}

export default RegressionModels;